import React, { useState } from 'react';
import SideBar from './SideBar';
import MainBar from './MainBar';
import AdminTopBar from './AdminTopBar';

const AdminLayout = ({ children }: any) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <div className="admin-layout">
      <SideBar mobileOpen={drawerOpen} onClose={() => setDrawerOpen(false)} />
      <div className="admin-main">
        <MainBar onMenuClick={() => setDrawerOpen(true)} />
        <div className="admin-main-inner">
          {children.props.location.pathname.split('/').length < 4 && <AdminTopBar />}
          <div className="admin-page-content">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
